import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';

const BucketsInput = ({
  buckets, ruleId, onValueChange,
}) => (
  <div className='buckets-container'>
    {buckets.map((bucket, index) => (
      <div key={bucket.label} className='bucket-row'>
        <span className='bucket-label'>{bucket.label}</span>
        <Input
          type='number'
          value={bucket.value}
          onChange={(e, data) => onValueChange(ruleId, 'bucket', {
            index,
            value: data.value,
          })}
          size='small'
        />
      </div>
    ))}
  </div>
);

BucketsInput.propTypes = {
  buckets: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    })
  ).isRequired,
  ruleId: PropTypes.string.isRequired,
  onValueChange: PropTypes.func.isRequired,
};

export default BucketsInput;
